import { Box, ListItem as MuiListItem } from '@mui/material';
import React from 'react';

type Props = {
    label: string;
    value?: string;
};

export const ListItem = ({ label, value }: Props) => {
    return (
        <MuiListItem
            sx={(theme) => ({
                color: 'primary.dark',
                fontSize: theme.typography.caption.fontSize,
                borderTop: '1px solid ' + theme.palette.divider,
            })}
        >
            <Box
                sx={(theme) => ({
                    fontFamily: 'OpenSans-Regular',
                    fontSize: theme.typography.caption.fontSize,
                    paddingRight: theme.spacing(),
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                    width: '40%',
                })}
            >
                {label}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '60%',
                    wordWrap: 'break-word',
                    textAlign: 'right',
                }}
            >
                {value}
            </Box>
        </MuiListItem>
    );
};
